import React from "react";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";
import { Container } from "react-bootstrap";

const ContactUs = () => {
  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px" }}>
        <h2>Contact Us</h2>
        <div className="mt-4">
          <p>
            If you have any questions or need assistance regarding our services, please feel free to reach out to us.
          </p>
          <p>
            <b>Email:</b> <a href="mailto:info@psychooncology.online">info@psychooncology.online</a>
          </p>
          <p>
            <b>Phone:</b> +91 9545 300 800
          </p>
          <p>
            <b>Address:</b> 17, Lane No. 2, Prashant Society, Kothrud, Pune, Maharashtra, India
          </p>
          <p>
            Our support team is available Monday to Friday, 9:00 AM to 6:00 PM IST. We look forward to assisting you.
          </p>
        </div>
      </Container>
      <CommonFooter />
    </>
  );
};

export default ContactUs;
